/**
 * Storezone — useTenant Hook
 *
 * Provides access to the TenantContext.
 * Must be used inside <TenantProvider>.
 */

import { useContext } from 'react'
import { TenantContext, type TenantContextValue } from '@/contexts/TenantContext'

export function useTenant(): TenantContextValue {
  const context = useContext(TenantContext)
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider')
  }
  return context
}
